import { render, staticRenderFns } from "./BrowserAgentLayout.vue?vue&type=template&id=549e1826&scoped=true"
import script from "./BrowserAgentLayout.vue?vue&type=script&lang=js"
export * from "./BrowserAgentLayout.vue?vue&type=script&lang=js"
import style0 from "./BrowserAgentLayout.vue?vue&type=style&index=0&id=549e1826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549e1826",
  null
  
)

export default component.exports